import React, { useEffect, useState } from 'react';
import { Button, Tooltip, Icon, Avatar, message } from 'antd';
import { UserDetailHeadingCover, TeamDetailsCard, DetailsCard, UserProfilecover } from './styles';
import Loader from '../../components/Loader';
import { LoginContainer } from '../../components/Modals/styles';
import { EfaxConfigModal } from '../../components/Modals';
import DeleteSMTPConfigModal from '../../components/Modals/DeleteSMTPConfigModal';
import { withTranslation } from 'react-i18next';
import { getAllEFaxUsers } from '../../utils/services/efaxAPI';
import { faxSvgIcon } from '../../components/SidebarMenuIcons';
import { MANAGE_FAX_CONFIGURATION as trans } from './TranslationValues';

const NAMESPACE = ['MANAGE_FAX_CONFIGURATION'];
const FaxConfigSettings = props => {
  const { t } = props;
  const [loading, setLoading] = useState(true);
  const [showModal, setShowModal] = useState(false);
  const [isEditing, setIsEditing] = useState(false);
  const [selectedItem, setSelectedItem] = useState('');
  const [userDetails, setUserDetails] = useState([]);
  const [deleteModalVisible, setDeleteModalVisible] = useState(false);

  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = async () => {
    setLoading(true);
    let response = await getAllEFaxUsers();
    if (response && response.statusCode === 673) {
      setUserDetails(response.data);
    } else {
      message.error(
        t(
          trans.UNABLE_TO_FETCH_FAX_DETAILS_ERROR_MESSAGE.key,
          trans.UNABLE_TO_FETCH_FAX_DETAILS_ERROR_MESSAGE.value,
        ),
      );
    }

    setLoading(false);
  };

  const renderList = () => {
    return (
      <>
        {userDetails &&
          userDetails.map((value, key) => {
            return (
              <DetailsCard key={key} user={true}>
                <UserProfilecover efax={true}>
                  <div
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      width: '45%',
                    }}
                  >
                    <Avatar className="avatar">{value?.configName?.charAt(0).toUpperCase()}</Avatar>
                    <p>{value.configName}</p>
                  </div>
                  <div
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      width: '40%',
                      justifyContent: 'flex-start',
                    }}
                  >
                    <div>
                      <Icon component={faxSvgIcon} />
                    </div>
                    <p>{value.faxNumber}</p>
                  </div>
                  <div
                    style={{
                      display: 'flex',
                      width: '25%',
                      justifyContent: 'space-around',
                      marginRight: '10px',
                    }}
                    onClick={e => e.stopPropagation()}
                  >
                    <Tooltip
                      placement="top"
                      title={t(
                        trans.EDIT_FAX_CONFIGURATION_TOOLTIP.key,
                        trans.EDIT_FAX_CONFIGURATION_TOOLTIP.value,
                      )}
                    >
                      <Icon
                        type="edit"
                        onClick={() => {
                          setShowModal(true);
                          setIsEditing(true);
                          setSelectedItem(value);
                        }}
                      />
                    </Tooltip>
                    <Tooltip
                      placement="top"
                      title={t(
                        trans.DELETE_FAX_CONFIGURATION_TOOLTIP.key,
                        trans.DELETE_FAX_CONFIGURATION_TOOLTIP.value,
                      )}
                    >
                      <Icon
                        type="delete"
                        onClick={() => {
                          setSelectedItem(value);
                          setDeleteModalVisible(true);
                        }}
                      />
                    </Tooltip>
                  </div>
                </UserProfilecover>
              </DetailsCard>
            );
          })}
      </>
    );
  };

  const onCancel = isUpdate => {
    setIsEditing(false);
    setShowModal(false);
    setDeleteModalVisible(false);

    if (isUpdate) {
      fetchData();
    }
  };
  return (
    <>
      {loading ? (
        <LoginContainer>
          <Loader />
        </LoginContainer>
      ) : (
        <>
          <UserDetailHeadingCover>
            <div>
              <h5>
                {t(
                  trans.MANAGE_FAX_CONFIGURATION_TITLE.key,
                  trans.MANAGE_FAX_CONFIGURATION_TITLE.value,
                )}
              </h5>
              <p>
                {t(
                  trans.MANAGE_FAX_CONFIGURATION_DESCRIPTION.key,
                  trans.MANAGE_FAX_CONFIGURATION_DESCRIPTION.value,
                )}
              </p>
            </div>
            <Button
              type="primary"
              className="add_user_btn"
              onClick={() => {
                setShowModal(true);
                setSelectedItem('');
              }}
            >
              {t(trans.ADD_FAX_CONFIGURATION_BUTTON.key, trans.ADD_FAX_CONFIGURATION_BUTTON.value)}
            </Button>
          </UserDetailHeadingCover>
          <TeamDetailsCard>{renderList()}</TeamDetailsCard>
          {showModal && (
            <EfaxConfigModal
              visible={showModal}
              onCancel={onCancel}
              targetUser={selectedItem}
              isEditing={isEditing}
              allEFaxUsers={userDetails}
            />
          )}
          {deleteModalVisible && (
            <DeleteSMTPConfigModal
              visible={deleteModalVisible}
              targetUser={selectedItem}
              onCancel={onCancel}
              isFaxUser={true}
            />
          )}
        </>
      )}
    </>
  );
};
export default withTranslation(NAMESPACE)(FaxConfigSettings);
